module.exports = __webpack_public_path__ + "img/20190626161228865.d5205d9d.png";